import React from 'react';

import './index.css';

const LoadingSpinner: React.FC = () => {
    return (
        <div className="loading-spinner-wrapper">
            <div className="loading-spinner"></div>
        </div>
    );
};

export default LoadingSpinner;
